// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('angular-ui-router'), require('ui/web/clientOverview/form').name];

module.exports = angular
  .module('bench.app.mainapp.details.overview.form.new', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.details.overview.form.new', {
      url: '/new',
      views: {
        'modal@': {
          controllerAs: 'vm',
          template: `\
<bl-client-overview-form></bl-client-overview-form>\
`,
        },
      },
    }),
  );
